import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { PiasLayoutComponent } from '../../shared/components/pias-layout/pias-layout.component';
import { Router, RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SessionStorageService } from '../../core/services/session-storage/session-storage.service';
import { SnackbarService } from '../../shared/services/snackbar/snackbar.service';
import { SelectOptions } from '../../core/interfaces/select-options.interface';
import { MatDividerModule } from '@angular/material/divider';
import { UsersService } from '../../core/services/users/users.service';
import { CreateNewUser } from '../../core/models/create-new-user/create-new-user.model';
import { HttpStatusCode } from 'axios';

@Component({
  selector: 'app-create-new-user',
  imports: [
    CommonModule,
    PiasLayoutComponent,
    RouterModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDividerModule
  ],
  templateUrl: './create-new-user.page.html',
  styleUrl: './create-new-user.page.scss'
})
export class CreateNewUserPage implements OnInit {

  private router = inject(Router);
  private formBuilder = inject(FormBuilder);
  private sessionStorageService = inject(SessionStorageService);
  private snackBarService = inject(SnackbarService);
  private usersService = inject(UsersService);

  protected readonly userRoles: SelectOptions[] = [
    {
      name: "Super Admin",
      value: "Super Admin"
    },
    {
      name: "Admin",
      value: "Admin"
    }
  ];

  protected readonly userStatus: SelectOptions[] = [
    {
      name: "Active",
      value: "Active"
    },
    {
      name: "Inactive",
      value: "Inactive"
    }
  ];

  createNewUserFg!: FormGroup;

  constructor() { }

  ngOnInit(): void {
    this.createNewUserFg = this.formBuilder.group({
      name: ["", [Validators.required]],
      email: ["", [Validators.required, Validators.email]],
      contactNo: ["", [Validators.required]],
      userRole: ["", [Validators.required]],
      username: ["", [Validators.required]],
      expiryDate: ["", [Validators.required]],
      userStatus: ["", [Validators.required]]
    });
  }

  onNameValueChange() {
    let name = this.createNewUserFg.get('name')?.value;

    this.createNewUserFg.controls['username'].patchValue(name);
  }

  async createNewUser() {
    let newUser = new CreateNewUser();

    newUser.setPersonName(this.createNewUserFg.get('name')?.value);
    newUser.setEmail(this.createNewUserFg.get('email')?.value);
    newUser.setContactno(this.createNewUserFg.get('contactNo')?.value);
    newUser.setUserCategory(this.createNewUserFg.get('userRole')?.value);
    newUser.setUsername(this.createNewUserFg.get('username')?.value);
    newUser.setUserPassword('Password');
    newUser.setUserExpiryDate(this.createNewUserFg.get('expiryDate')?.value);
    newUser.setIsActive(this.createNewUserFg.get('userStatus')?.value === 'Active' ? true : false);

    console.log(newUser.toString());

    const responseData = await this.usersService
      .createNewUser(newUser)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        console.error(error);
        return error;
      });

    if(responseData.status === HttpStatusCode.Ok) {
      this.snackBarService.openSuccessSnackBar(responseData.data.message);
      this.createNewUserFg.reset();
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("Something went wrong!!!");
      }
      if(responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

}
